<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card style="margin-bottom:10px">
                <el-input v-model="search.project_name"
                          :clearable="true"
                          placeholder="请输入项目名称"
                          size="small"
                          style="width: 200px"></el-input>

                <el-button type="primary"
                           size="small"
                           icon="el-icon-search"
                           @click="doSearch()">搜索</el-button>
              </el-card>

              <el-tabs v-model="activeTab"
                       type="border-card"
                       @tab-click="tabsChange">
                <el-tab-pane label="立项审核"
                             name="1">
                  <WtDataTable ref="tables1"
                               :search="search"
                               v-if="activeTab == 1"
                               :listUrl="$db.config.com_project.audit.approval">
                    <template slot="columns">
                      <el-table-column label="项目名称"
                                       min-width="250">
                        <template slot-scope="scope">
                          <a href="JavaScript:;"
                             @click="goDetail(scope.row)">{{scope.row.full_project_name}}</a>
                          <div style="color:#666">{{scope.row.regdate_start}}至{{scope.row.regdate_end}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="立项类型"
                                       align="center"
                                       width="180">
                        <template slot-scope="scope">
                          <span>{{scope.row.project_before_type_text}}</span>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="cat_id_text" label="合作体系" align="center" width="130"></el-table-column> -->
                      <el-table-column prop="apply_time"
                                       label="申请时间"
                                       align="center"
                                       width="120"></el-table-column>
                      <el-table-column prop="unit_name"
                                       label="申请执行机构"
                                       align="center"
                                       width="150"></el-table-column>
                      <el-table-column prop="total_funds"
                                       label="预算总金额"
                                       align="center"
                                       width="150">
                        <template slot-scope="scope">
                          <span>{{scope.row.total_funds | setNumFormat}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="status_text"
                                       label="状态"
                                       width="100"
                                       align="center"></el-table-column>
                      <el-table-column label="操作"
                                       align="center"
                                       width="220"
                                       fixed="right">
                        <template slot-scope="scope">
                          <el-button-group>
                            <el-button type="primary"
                                       icon="el-icon-edit"
                                       @click="startAudit(scope.row)"
                                       :disabled="!scope.row.if_option"
                                       size="mini">立项审核</el-button>
                          </el-button-group>
                        </template>
                      </el-table-column>
                    </template>
                  </WtDataTable>
                </el-tab-pane>
                <el-tab-pane label="结项审核"
                             name="2">
                  <WtDataTable ref="tables2"
                               :search="search"
                               v-if="activeTab == 2"
                               :listUrl="$db.config.com_project.audit.end">
                    <template slot="columns">
                      <el-table-column label="项目名称"
                                       min-width="250">
                        <template slot-scope="scope">
                          <a href="JavaScript:;"
                             @click="goDetail1(scope.row)">{{scope.row.project_name}}</a>
                          <div style="color:#666">{{scope.row.regdate_start}}至{{scope.row.regdate_end}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="立项类型"
                                       align="center"
                                       width="180">
                        <template slot-scope="scope">
                          <span>{{scope.row.project_before_type_text}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="node_time"
                                       label="结项时间"
                                       align="center"
                                       width="120"></el-table-column>
                      <el-table-column prop="unit_name"
                                       label="申请执行机构"
                                       align="center"
                                       width="150"></el-table-column>
                      <el-table-column label="操作"
                                       align="center"
                                       width="300"
                                       fixed="right">
                        <template slot-scope="scope">
                          <el-button-group>
                            <el-button type="danger"
                                       icon="el-icon-edit"
                                       @click="endAudit(scope.row)"
                                       size="mini">结项审核</el-button>
                          </el-button-group>
                        </template>
                      </el-table-column>
                    </template>
                  </WtDataTable>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-dialog :visible.sync="auditModal1"
                 width="40%"
                 :before-close="cancelBtn1">
        <div slot="title">
          “
          <span style="color:red">{{audit_title1.unit_name}}</span>
          ” 的 “
          <span style="color:red">{{audit_title1.pro_name}}</span>
          ” 项目申请审核
        </div>

        <p style="font-weight:bold;padding-bottom:10px">{{money_info}}</p>
        <p style="color:red;padding-bottom:10px">建议在列表点击 “项目名称” 查看该立项项目详细信息，再进行审核操作~</p>

        <p style="margin-bottom:10px">审核意见：</p>
        <el-input type="textarea"
                  v-model="auditForm1.province_audit_opinion
"
                  :rows="2"
                  style="width:85%"></el-input>
        <span slot="footer">
          <el-button-group>
            <el-button type="primary"
                       @click="doAudit1(1)"
                       :loading="loading1"
                       icon="el-icon-check"
                       size="small">审核通过</el-button>
            <el-button type="danger"
                       @click="doAudit1(2)"
                       :loading="loading1"
                       icon="el-icon-close"
                       size="small">审核不通过</el-button>
            <el-button type="danger"
                       icon="el-icon-close"
                       plain
                       @click="cancelBtn1"
                       size="small">取消</el-button>
          </el-button-group>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="auditModal2"
                 width="40%"
                 :before-close="cancelBtn2">
        <div slot="title">
          “
          <span style="color:red">{{audit_title2.unit_name}}</span>
          ” 的 “
          <span style="color:red">{{audit_title2.pro_name}}</span>
          ” 项目结项审核
        </div>

        <el-row type="flex"
                justify="center"
                style="padding:10px">
          <el-col :span="10">结项发起人：{{endInfo.apply_user_name}}</el-col>
          <el-col :span="10">结项日期：{{endInfo.node_time}}</el-col>
        </el-row>

        <el-row type="flex"
                justify="center"
                style="padding:10px">
          <el-col :span="20">结项原因：{{endInfo.reasons}}</el-col>
        </el-row>

        <el-row type="flex"
                justify="center"
                style="padding:10px">
          <el-col :span="20">
            结项附件：
            <!-- <a
              href="javascript:;"
              @click="downFile(endInfo.file_id,endInfo.file_source_name)"
            >{{endInfo.file_source_name}}</a> -->
            <a :href="endInfo.file_url"
               target="_blank">{{endInfo.file_source_name}}</a>
          </el-col>
        </el-row>

        <el-row type="flex"
                justify="center"
                style="padding:10px">
          <el-col :span="20">
            摘要：
            本项目自
            <i>{{abstract.regdate_start}}</i>至
            <i>{{abstract.regdate_end}}</i> 的实施期间，累计受益总人数为
            <i>{{abstract.beneficiary_number}}</i>，其中筛查
            <i>{{abstract.screen_sum}}</i>人，
            筛查出的患者中有
            <i>{{abstract.apply_count}}</i>名入院复诊接受治疗，合计使用该项目款
            <i>{{abstract.approve_sum}}</i> 元，此外医保补助总额为
            <i>{{abstract.yb_sum}}</i> 元。
          </el-col>
        </el-row>

        <el-row type="flex"
                justify="center"
                style="padding:10px">
          <el-col :span="20">
            <p style="padding-bottom:10px">审核意见：</p>
            <el-input type="textarea"
                      v-model="auditForm2.province_audit_opinion"
                      :rows="2"
                      style="width:90%"></el-input>
          </el-col>
        </el-row>

        <span slot="footer">
          <el-button-group>
            <el-button type="primary"
                       @click="doAudit2(1)"
                       :loading="loading2"
                       icon="el-icon-check"
                       size="small">审核通过</el-button>
            <el-button type="danger"
                       @click="doAudit2(2)"
                       :loading="loading2"
                       icon="el-icon-close"
                       size="small">审核不通过</el-button>
            <el-button type="danger"
                       icon="el-icon-close"
                       plain
                       @click="cancelBtn2"
                       size="small">取消</el-button>
          </el-button-group>
        </span>
      </el-dialog>

      <detail v-if="if_open"
              v-model="if_open"
              :id="approval_id"></detail>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import detail from "../approval/detail";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    detail
  },
  data () {
    return {
      search: { project_name: null },
      activeTab: "1", //tab

      approval_id: null,
      project_id: null,

      money_info: null, //项目相关金额信息

      if_open: false,
      auditModal1: false,
      audit_title1: {
        unit_name: null,
        pro_name: null
      },
      auditForm1: {
        province_audit_opinion: null //审核意见
      },

      auditModal2: false,
      audit_title2: {
        unit_name: null,
        pro_name: null
      },
      auditForm2: {
        province_audit_opinion: null //审核意见
      },
      endInfo: {}, //结项信息详情

      loading1: false,
      loading2: false,

      abstract: {} //结项项目摘要
    };
  },
  methods: {
    //千分化金额
    // setMoneyFormat(num) {
    //   return (num.toFixed(2) + "").replace(
    //     /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
    //     "$&,"
    //   );
    // },

    tabsChange (val) {
      this.search.project_name = null;
    },

    doSearch () {
      this.$refs["tables" + this.activeTab].handleSearch();
    },

    //立项详情
    goDetail (row) {
      this.approval_id = row.id;
      this.if_open = true;
    },

    //公益项目详情
    goDetail1 (row) {
      this.$router.push({
        path: "/hospitalComProjectInfo",
        query: { id: row.id }
      });
    },

    //获取结项项目摘要（结项资料）
    getAbstract (pid) {
      this.$db
        .post(this.$db.config.getProjectPublicNodeTotal, { id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.abstract = res.data;
          }
        });
    },

    //获取项目的相关金额
    getMoney (id) {
      this.$db
        .post(this.$db.config.com_project.audit.money, { id: id })
        .then(res => {
          if (res && res.code == 200) {
            this.money_info = res.msg;
          }
        });
    },

    //立项审核
    startAudit (row) {
      this.getMoney(row.id);
      this.audit_title1.unit_name = row.unit_name;
      this.audit_title1.pro_name = row.project_name;
      this.auditForm1.id = row.id;
      this.auditModal1 = true;
    },

    //下载文件
    downFile (id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download (data, name) {
      if (!data) {
        return;
      }

      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //立项审核
    doAudit1 (audit) {
      if (!this.auditForm1.province_audit_opinion && audit == 2) {
        this.$message.warning("请填写审核意见！");
        return;
      }
      this.loading = true;
      this.auditForm1.province_audit_status = audit;
      this.$db
        .post(this.$db.config.com_project.audit.start_audit, this.auditForm1)
        .then(res => {
          this.loading = false;
          if (res && res.code == 200) {
            this.$message.success(res.msg);
            this.cancelBtn1();
            this.$refs.tables1.reloadData();
          }
        });
    },

    //
    cancelBtn1 () {
      this.activeTab = "1";
      this.auditForm1.id = null;
      this.auditForm1.province_audit_opinion = null;
      this.auditModal1 = false;
    },

    //结项审核
    endAudit (row) {
      this.getEndInfo(row.id);
      this.getAbstract(row.id);
      this.audit_title2.unit_name = row.unit_name;
      this.audit_title2.pro_name = row.project_name;
      this.auditForm2.id = row.node_id;
      this.auditModal2 = true;
    },

    cancelBtn2 () {
      this.activeTab = "2";
      this.auditForm2.id = null;
      this.auditForm2.province_audit_opinion = null;
      this.auditModal2 = false;
    },

    //查看结项信息
    getEndInfo (pid) {
      this.$db
        .post(this.$db.config.getProjectEndInfo, { project_id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.endInfo = res.data;
          }
        });
    },

    //结项审核
    doAudit2 (audit) {
      if (!this.auditForm2.province_audit_opinion && audit == 2) {
        this.$message.warning("请填写结项审核意见！");
        return;
      }
      this.loading2 = true;
      this.auditForm2.province_audit_status = audit;
      this.$db
        .post(this.$db.config.com_project.audit.end_audit, this.auditForm2)
        .then(res => {
          this.loading2 = false;
          if (res && res.code == 200) {
            this.$message.success(res.msg);
            this.cancelBtn2();
            this.$refs.tables2.reloadData();
          }
        });
    }
  },
  mounted () { }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/audit/list.vue